import { adminUsersQueryKeys as e } from "./adminUsersQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/users/admin/useAdminUsersQuery.ts
var r = (r = {}) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.adminListUsers({
		...r,
		page: e
	}),
	key: "users"
});
//#endregion
export { r as useAdminUsersQuery };
